import React from "react";
import { JAPAN_COURSES } from "../../data/courseDataJapan";

const formatJpy = (amount) => `¥${amount.toLocaleString("ja-JP")}`;

const JapanCourses = ({ activeTab, onTabChange, onBookDemo }) => {
  const tabs = Object.keys(JAPAN_COURSES);

  return (
    <section id="jl-courses" className="jl-section jl-courses">
      <div className="container">
        <header className="section-header wow fadeInUp">
          <span className="jl-section-label">コースと料金</span>
          <h2 className="about_head">
            あなたに合ったコースを選んで、
            <span className="highlighted-text">学習をスタート</span>
          </h2>
          <p className="jl-section-subtitle">
            すべてのコースにライブ授業、教材、修了証が含まれます。
          </p>
        </header>

        <div className="jl-tabs wow fadeInUp">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`jl-tab-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => onTabChange(tab)}
            >
              {JAPAN_COURSES[tab].flag} {JAPAN_COURSES[tab].label}
            </button>
          ))}
        </div>

        <div className="jl-courses-grid">
          {JAPAN_COURSES[activeTab].courses.map((course, index) => (
            <div
              key={course.title}
              className={`jl-course-card box course-card wow fadeInUp ${
                course.popular ? "jl-course-card--popular" : ""
              }`}
              data-wow-delay={`${index * 0.1}s`}
            >
              {course.popular && (
                <span className="jl-course-card__badge">人気No.1</span>
              )}
              <span className="jl-course-card__level">{course.level}</span>
              <h4 className="highlighted-text">{course.title}</h4>
              <ul>
                <li>ライブオンライン授業</li>
                <li>期間: {course.duration}</li>
                <li>修了証発行</li>
              </ul>
              <div className="jl-course-card__price">
                <span className="jl-course-card__price-strike">
                  {formatJpy(course.originalPrice)}
                </span>
                <span className="jl-course-card__price-current">
                  {formatJpy(course.price)}
                </span>
              </div>
              <button
                type="button"
                className="pay-btn"
                onClick={() =>
                  onBookDemo(JAPAN_COURSES[activeTab].label, course.formLevel, activeTab)
                }
              >
                無料体験を予約
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JapanCourses;
